import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reserve-home-lot-modal"
}
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "header-logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-section" }
const _hoisted_9 = { class: "form-subsection" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-subsection" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "radio-group" }
const _hoisted_16 = { class: "radio-option" }
const _hoisted_17 = { class: "radio-option" }
const _hoisted_18 = { class: "radio-option" }
const _hoisted_19 = { class: "radio-option" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "checkbox-group" }
const _hoisted_22 = { class: "checkbox-option" }
const _hoisted_23 = { class: "checkbox-option" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "summary-section" }
const _hoisted_26 = { class: "summary-image" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  key: 1,
  class: "image-placeholder"
}
const _hoisted_29 = { class: "summary-details" }
const _hoisted_30 = { class: "detail-row" }
const _hoisted_31 = { class: "detail-value" }
const _hoisted_32 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_33 = { class: "detail-value" }
const _hoisted_34 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_35 = { class: "detail-value" }
const _hoisted_36 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_37 = { class: "detail-value" }
const _hoisted_38 = {
  key: 3,
  class: "specs-row"
}
const _hoisted_39 = {
  key: 0,
  class: "spec-item"
}
const _hoisted_40 = {
  key: 1,
  class: "spec-item"
}
const _hoisted_41 = {
  key: 2,
  class: "spec-item"
}
const _hoisted_42 = {
  key: 3,
  class: "spec-item"
}
const _hoisted_43 = { class: "price-section" }
const _hoisted_44 = { class: "price-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        ($props.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "modal-backdrop",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "back-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("span", null, "← Back", -1)
                  ]))]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "header-nav" }, [
                    _createElementVNode("button", { class: "nav-btn active" }, "View Map"),
                    _createElementVNode("button", { class: "nav-btn" }, "Resources")
                  ], -1)),
                  _createElementVNode("div", _hoisted_4, [
                    ($props.projectPage?.residentialContent?.logoImageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $props.projectPage.residentialContent.logoImageUrl,
                          alt: "Logo"
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.projectPage?.residentialContent?.brandText || "Logo"), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "form-title" }, "Submit Your Expression of Interest", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "subsection-title" }, "Your Details", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", null, "Full Name *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.fullName) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, $setup.formData.fullName]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Email Address *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.email) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, $setup.formData.email]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Phone Number *", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "tel",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.phone) = $event)),
                          placeholder: ""
                        }, null, 512), [
                          [_vModelText, $setup.formData.phone]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "subsection-title" }, "Your Preferences", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", null, "Preferred Timeframe", -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.timeframe) = $event)),
                              value: "immediately"
                            }, null, 512), [
                              [_vModelRadio, $setup.formData.timeframe]
                            ]),
                            _cache[18] || (_cache[18] = _createElementVNode("span", null, "Immediately", -1))
                          ]),
                          _createElementVNode("label", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.formData.timeframe) = $event)),
                              value: "3-6"
                            }, null, 512), [
                              [_vModelRadio, $setup.formData.timeframe]
                            ]),
                            _cache[19] || (_cache[19] = _createElementVNode("span", null, "3-6 months", -1))
                          ]),
                          _createElementVNode("label", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.formData.timeframe) = $event)),
                              value: "6-12"
                            }, null, 512), [
                              [_vModelRadio, $setup.formData.timeframe]
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("span", null, "6-12 months", -1))
                          ]),
                          _createElementVNode("label", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.formData.timeframe) = $event)),
                              value: "12+"
                            }, null, 512), [
                              [_vModelRadio, $setup.formData.timeframe]
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("span", null, "12+ months", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "Finance Status", -1)),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formData.preApproved) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, $setup.formData.preApproved]
                            ]),
                            _cache[23] || (_cache[23] = _createElementVNode("span", null, "Pre-approved for finance", -1))
                          ]),
                          _createElementVNode("label", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.formData.cashBuyer) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, $setup.formData.cashBuyer]
                            ]),
                            _cache[24] || (_cache[24] = _createElementVNode("span", null, "Cash buyer", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Additional Notes", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.formData.notes) = $event)),
                          rows: "4",
                          placeholder: "Any questions or special requirements..."
                        }, null, 512), [
                          [_vModelText, $setup.formData.notes]
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "submit-btn",
                      onClick: $setup.handleSubmit
                    }, "Submit Expression of Interest")
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "summary-title" }, "Your Selection Summary", -1)),
                    _createElementVNode("div", _hoisted_26, [
                      ($setup.houseImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.houseImage,
                            alt: $props.house?.name || 'House'
                          }, null, 8, _hoisted_27))
                        : (_openBlock(), _createElementBlock("div", _hoisted_28, "🏠"))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "detail-label" }, "Design", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString($props.house?.name || "-"), 1)
                      ]),
                      ($props.selectedFacade)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "detail-label" }, "Style", -1)),
                            _createElementVNode("span", _hoisted_33, _toDisplayString($props.selectedFacade.name) + " Facade", 1)
                          ]))
                        : _createCommentVNode("", true),
                      ($props.selectedColorScheme)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "detail-label" }, "Internal Colour Scheme", -1)),
                            _createElementVNode("span", _hoisted_35, _toDisplayString($props.selectedColorScheme.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ($props.selectedLot)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "detail-label" }, "Lot Number", -1)),
                            _createElementVNode("span", _hoisted_37, "Lot " + _toDisplayString($props.selectedLot.title), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.hasSpecs)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            ($props.house?.bedroom)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode($setup["Bed"], {
                                    class: "spec-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($props.house.bedroom), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.bathroomCount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createVNode($setup["Bath"], {
                                    class: "spec-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($setup.bathroomCount), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($props.house?.garage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createVNode($setup["Car"], {
                                    class: "spec-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($props.house.garage), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($props.house?.area)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createVNode($setup["Maximize2"], {
                                    class: "spec-icon",
                                    size: 16
                                  }),
                                  _createElementVNode("span", null, _toDisplayString($props.house.area) + "m²", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "divider" }, null, -1)),
                      _createElementVNode("div", _hoisted_43, [
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "price-label" }, "Estimated Price", -1)),
                        _createElementVNode("span", _hoisted_44, _toDisplayString($setup.displayPrice), 1),
                        _cache[34] || (_cache[34] = _createElementVNode("p", { class: "price-note" }, "Price is indicative and subject to change", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}